
import Grid from '.';
import { SCROLLABLE_BY_WHEEL_REF_NAME } from '../../mixins/scroll-wheel-horizontal/constants';
import { DEFAULT_GRID_SIZES } from './constants';
import { GridHeaderPropsEventType } from './enums';
import GridPaginationEntity from './components/pagination/entities/GridPagination';
import {
  DEFAULT_ACTIVE_PAGE,
  PAGINATION_ITEMS_PER_PAGE_OPTIONS,
} from './components/pagination/constants';

const TABLE_HEADER_REF_NAME = 'grid-header';

export default {
  name: 'GridSync',
  components: {
    Grid,
  },
  props: {
    columns: {
      default: () => [],
      type: Array,
    },
    rows: {
      default: () => [],
      type: Array,
    },
    sizes: {
      default: () => DEFAULT_GRID_SIZES,
      type: Array,
    },
    itemsPerPageOptions: {
      default: () => PAGINATION_ITEMS_PER_PAGE_OPTIONS,
      type: Array,
    },
    hasPagination: {
      default: false,
      type: Boolean,
    },
    isCollapsed: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      pagination: null,
      GridHeaderPropsEventType,
      SCROLLABLE_BY_WHEEL_REF_NAME,
      TABLE_HEADER_REF_NAME,
    };
  },
  computed: {
    visibleRows() {
      return this.getPaginatedRows(this.rows);
    },
    isTableVisible() {
      return !this.hasPagination || this.pagination;
    },
  },
  watch: {
    rows() {
      this.initPagination();
    },
  },
  mounted() {
    this.initPagination();
  },
  methods: {
    getPaginatedRows(rows) {
      return rows.slice(this.pagination?.firstIndexOnPage, this.pagination?.lastIndexOnPage);
    },
    initPagination() {
      if (!this.hasPagination) {
        return;
      }

      if (this.pagination) {
        this.updatePagination();
      } else {
        this.createPagination();
      }
    },
    updatePagination(options = {}) {
      this.pagination.setOptions({
        ...options,
        totalItems: this.rows.length,
      });
    },
    createPagination() {
      this.pagination = new GridPaginationEntity({
        pageNumber: DEFAULT_ACTIVE_PAGE,
        pageSize: this.itemsPerPageOptions[0].value,
        totalItems: this.rows.length,
      });
    },
    handleSortingChange(options) {
      this.pagination.setPageNumber(DEFAULT_ACTIVE_PAGE);
      this.sortOptions = options;
    },
    handlePaginationChange(options) {
      this.updatePagination(options);
    },
  },
};
